const ALLOWED_RETURN_URL_PREFIXES = ['/eg', '/engage'];

export const sanitizeReturnUrl = returnUrl => {
  if (!returnUrl || typeof returnUrl !== 'string') {
    return null;
  }

  const trimmed = returnUrl.trim();
  if (!trimmed) {
    return null;
  }

  try {
    const url = new URL(trimmed, window.location.origin);
    if (url.origin !== window.location.origin) {
      return null;
    }

    const normalizedPath = `${url.pathname}${url.search}${url.hash}`;
    if (!normalizedPath.startsWith('/')) {
      return null;
    }

    const isAllowedPath = ALLOWED_RETURN_URL_PREFIXES.some(prefix => normalizedPath === prefix || normalizedPath.startsWith(`${prefix}/`));
    return isAllowedPath ? normalizedPath : null;
  } catch (error) {
    return null;
  }
};
